module.exports = __webpack_public_path__ + "img/coco-club-04.bad40330.jpg";